<template>
  <account-layout>
    <el-form :model="signUpForm" :rules="signUpRules" ref="signUpForm">
      <el-row :gutter="60">
        <el-col :span="24" :md="24" :sm="24" :xs="24">
          <upload-item v-model="imgUrlObj"  :type="'members'" :label="'Members'"/>
        </el-col>
        <el-col :span="24">
          <div class="su-title">Create Your Account</div>
          <div class="su-subtitle">Please create your Assemble User account. Additional members, such as family members, can be created after login.</div>
        </el-col>
        <el-col :span="24" class="row-space">
          <div>Email<span class="required">*</span></div>
          <el-form-item prop="email">
            <el-input class="input-space" type="email" name="email" v-model="signUpForm.email" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>Confirm Email<span class="required">*</span></div>
          <el-form-item prop="confirmEmail">
            <el-input class="input-space" name="confirmEmail"  v-model="signUpForm.confirmEmail" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" class="mb-10">
          <div>Password<span class="required">*</span></div>
          <el-form-item prop="password">
            <el-input class="input-space" type="password" name="password" v-model="signUpForm.password" placeholder="Type here..." show-password/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="nationalId === 4">
          <div>Confirm Password<span class="required">*</span></div>
          <el-form-item prop="confirmPassword">
            <el-input class="input-space" type="password" name="confirmPassword" v-model="signUpForm.confirmPassword" placeholder="Type here..." show-password/>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="row-space">
          <div>First Name<span class="required">*</span></div>
          <el-form-item prop="firstName">
            <el-input class="input-space" name="firstName" v-model="signUpForm.firstName" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>Last Name<span class="required">*</span></div>
          <el-form-item prop="lastName">
            <el-input class="input-space" name="lastName" v-model="signUpForm.lastName" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>Mobile<span class="required">*</span></div>
          <el-form-item prop="mobile">
            <vue-tel-input
             autoFormat
             autoDefaultCountry
             :defaultCountry="countryCode"
             dropdownOptions.showDialCodeInSelection="false"
             @open="openFlagDropdown = true"
            @close="openFlagDropdown = false"
            @country-changed="handleCountryChanged"
             v-model="signUpForm.mobile">
              <template v-slot:arrow-icon>
                <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
              </template>
            </vue-tel-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>Birthdate<span class="required">*</span></div>
          <el-form-item prop="birthdate">
            <el-date-input class="input-space" name="birthdate" v-model="signUpForm.birthdate" placeholder="DD/MM/YYYY"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>Country<span class="required">*</span></div>
          <el-form-item prop="country">
            <el-autocomplete
              class="mt-05 w-100"
              v-model="signUpForm.country"
              :fetch-suggestions="searchCountry"
              placeholder="Select"
              name="country"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>Gender<span class="required">*</span></div>
          <el-form-item prop="gender">
            <el-select class="input-space w-100" name="gender" v-model="signUpForm.gender" filterable :filter-method="handleGenderFilter" placeholder="Select" autocomplete>
              <el-option
                v-for="item in filterGender"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="24" class="term">
          <el-checkbox v-model="signUpForm.acceptPromotion"></el-checkbox>
          Accept promotion
        </el-col> -->
        <el-col :span="24" class="term">
          <el-checkbox v-model="signUpForm.acceptTerm" name="acceptTerm"></el-checkbox>
          I agree to the <a href="https://assemble-sports-assets.s3-ap-southeast-2.amazonaws.com/documents/Assemble+Terms+and+Conditions.pdf" target="_blank">Terms and Conditions</a>
        </el-col>
        <el-col :span="24" v-if="errorMessage" class="row-space">
          <el-alert show-icon type="error" :title="errorMessage" :closable="false" />
        </el-col>
      </el-row>
      <el-row class="row-space">
        <el-col :span="24">
          <el-button
            type="primary"
            class="ac-btn"
            @click="register"
          >Create Account</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24" class="t-center">
        Already have an account?
        <el-button type="text" @click="login">Login</el-button>
      </el-col>
    </el-row>
    <el-dialog
      title="Is this you?"
      :visible.sync="confirmDialog"
      width="30%">
      <div v-if="this.foundUser">
        <p>
          <span>
            Name: {{ get(this.foundUser, 'firstName')}} {{ get(this.foundUser, 'lastName') }}
          </span>
        </p>
        <p>
          <span>
            DOB: {{ get(this.foundUser, 'dob') }}
          </span>
        </p>
        <p>
          <span>
            Gender: {{ get(this.foundUser, 'gender') }}
          </span>
        </p>
        <p>
          <span>
            Email: {{ get(this.foundUser, 'email') }}
          </span>
        </p>
        <p>
          <span>
            Mobile: {{ get(this.foundUser, 'mobile') }}
          </span>
        </p>
        <p>
          <span>
            Address: {{ get(this.foundUser, 'address.formatted') }}
          </span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialog = false">No</el-button>
        <el-button type="primary" @click="confirmAccount">Yes</el-button>
      </span>
    </el-dialog>
  </account-layout>
</template>

<script>
import moment from 'moment';
import { VueTelInput } from 'vue-tel-input';
import _ from 'lodash';
import { getContrastColor } from '@/utils/helpers';
import { datadogRum } from '@datadog/browser-rum';
import UploadItem from '../members/components/UploadItem.vue';
import AccountLayout from './AccountLayout.vue';
import { countries } from '../../utils/constants';

const PasswordValidator = require('password-validator');
const { parsePhoneNumberFromString } = require('libphonenumber-js/max');

const passwordSchema = new PasswordValidator();

export default {
  name: 'AccountSignUp',
  components: {
    AccountLayout,
    VueTelInput,
    UploadItem,
  },
  props: {
    platform: String,
    entityLevel: String,
    entityName: String,
  },
  async mounted() {
    // window.addEventListener('resize', this.handleResize);
    // this.handleResize();
    let textColorPrimary = '';
    let textColorSecondary = '';
    if (this.entityLevel && this.entityName) {
      if (this && this.$store) {
        await this.$store.dispatch('national/getSlugBranding', { entityLevel: this.entityLevel, entityName: this.entityName });
      }
      const meta = this.$store.getters['national/getMeta'];
      if (meta && meta.primaryColor && meta.secondaryColor) {
        textColorPrimary = getContrastColor(meta.primaryColor);
        textColorSecondary = getContrastColor(meta.secondaryColor);
        document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
        document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
      } else {
        textColorPrimary = getContrastColor(meta.primaryColor);
        textColorSecondary = getContrastColor(meta.secondaryColor);
        document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
        document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
      }
    } else {
      if (this && this.$store) {
        // await this.$store.dispatch('national/getSlugBranding', { entityLevel: this.entityLevel, entityName: this.entityName });
        this.$store.commit('national/resetCustom', {});
      }
      textColorPrimary = getContrastColor(process.env.VUE_APP_HIGHLIGHT_COLOR);
      textColorSecondary = getContrastColor(process.env.VUE_APP_SECONDARY_COLOR);
      document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
      document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    }
    document.documentElement.style.setProperty('--text-color-primary', textColorPrimary);
    document.documentElement.style.setProperty('--text-color-secondary', textColorSecondary);
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Email is required'));
      }
      const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      if (re.test(String(value).toLowerCase())) return callback();
      return callback(new Error('Invalid email address'));
    };
    const checkConfirmEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please confirm your email'));
      }
      if (value === this.signUpForm.email) return callback();
      return callback(new Error('Emails do not match, Please check again!'));
    };
    const checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Password is required'));
      }
      if (+process.env.VUE_APP_NATIONAL_ID === 19 || (+process.env.VUE_APP_NATIONAL_ID === 1 && process.env.VUE_APP_PIN_ENV === 'test')) {
        passwordSchema
          .is().min(8) // Minimum length 8
          .has().lowercase() // Must have lowercase letters
          .has()
          .symbols() // Must have symbols
          .has()
          .not()
          .spaces(); // Should not have spaces
        if (passwordSchema.validate(value)) return callback();
        return callback(new Error('Password must be at least 8 characters and special characters.'));
      }
      passwordSchema
        .is().min(8)
        .has().uppercase()
        .has()
        .lowercase()
        .has()
        .symbols()
        .has()
        .not()
        .spaces();
      if (passwordSchema.validate(value)) return callback();
      return callback(new Error('Password must be at least 8 characters with uppercase, lowercase and special characters.'));
    };
    const checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please confirm your password'));
      }
      if (value === this.signUpForm.password) return callback();
      return callback(new Error('Password do not match, Please try again!'));
    };
    const checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Mobile is required'));
      }
      // join value remomve all space
      // eslint-disable-next-line no-param-reassign
      value = value.replace(/\s/g, '');
      const phoneNumber = parsePhoneNumberFromString(value, this.countryCode);
      const test = !!(((phoneNumber && phoneNumber.isValid() && (phoneNumber.getType() === 'MOBILE' || phoneNumber.getType() === 'FIXED_LINE_OR_MOBILE'))));
      if (test) return callback();

      return callback(new Error('Invalid mobile'));
    };
    const checkBirthdate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Birthdate is required'));
      }
      const re = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
      if (re.test(String(value).toLowerCase())) return callback();
      return callback(new Error('Invalid birth date'));
    };

    return {
      get: _.get,
      imgUrlObj: {},
      openFlagDropdown: false,
      countryDialCode: this.getCountryDialCode(),
      countryCode: this.getCountryCode(),
      countries,
      errorMessage: '',
      signUpForm: {
        email: '',
        confirmEmail: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        mobile: '',
        birthdate: '',
        country: '',
        gender: '',
        acceptPromotion: false,
        acceptTerm: false
      },
      genderOptions: [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Other', label: 'Other' }
      ],
      signUpRules: {
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],
        confirmEmail: [
          { validator: checkConfirmEmail, trigger: 'blur' }
        ],
        password: [
          { validator: checkPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: checkConfirmPassword, trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        mobile: [
          { validator: checkMobile, trigger: 'blur' }
        ],
        birthdate: [
          { validator: checkBirthdate, trigger: 'blur' }
        ],
        country: [
          { required: true, message: 'Country is required', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: 'Gender is required', trigger: 'blur' }
        ]
      },
      confirmDialog: false,
      foundUser: {},
      fromAdmin: false,
    };
  },
  methods: {
    getCountryDialCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return '64'; // New Zealand
        case 21:
          return '65'; // Singapore
        default:
          return '61'; // Australia (default)
      }
    },

    getCountryCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return 'NZ'; // New Zealand
        case 21:
          return 'SG'; // Singapore
        default:
          return 'AU'; // Australia (default)
      }
    },
    dupplicateAccount() {
      this.confirmDialog = false;
      this.errorMessage = 'An existing account with the same email already exists.';
    },
    confirmAccount() {
      this.confirmDialog = false;
      this.fromAdmin = true;
      this.register();
    },
    handleCountryChanged(countryCode) {
      this.countryDialCode = countryCode.dialCode;
      this.countryCode = countryCode.iso2.toUpperCase();
    },
    handleGenderFilter(val) {
      if (val) {
        this.filterGender = this.genderOptions.filter((item) => item.value.charAt(0).toLowerCase() === val.charAt(0).toLowerCase());
      } else {
        this.filterGender = this.genderOptions;
      }
    },
    searchCountry(query, cb) {
      if (query && query !== '') {
        setTimeout(() => {
          cb(this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1));
        }, 200);
      } else {
        cb([]);
      }
    },
    register() {
      this.errorMessage = '';
      this.$refs.signUpForm.validate((valid) => {
        if (valid) {
          if (this.signUpForm.acceptTerm === false) this.errorMessage = 'Please accept terms before continue';
          else {
            let mobile = _.cloneDeep(this.signUpForm.mobile).replace(/\s/g, '');
            if (mobile.charAt(0) === '0') {
              mobile = mobile.substring(1);
              this.signUpForm.mobile = `+${ this.countryDialCode }${mobile}`;
            } else if (mobile.charAt(0) === '+') {
              this.signUpForm.mobile = `${mobile}`;
            } else {
              this.signUpForm.mobile = `+${ this.countryDialCode }${mobile}`;
            }
            this.$store.commit('loading', { loading: true, text: 'Loading...' });
            this.$http.post(`/assemble/api/v1/account/${this.platform}/users`, {
              email: this.signUpForm.email,
              password: this.signUpForm.password,
              firstName: this.signUpForm.firstName,
              lastName: this.signUpForm.lastName,
              dob: moment(this.signUpForm.birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              mobile: this.signUpForm.mobile,
              gender: this.signUpForm.gender,
              acceptPromotion: this.signUpForm.acceptPromotion,
              imgUrlObj: this.imgUrlObj,
              fromAdmin: this.fromAdmin
            }).then((res) => {
              this.$store.commit('user/login', res.data);
              this.$router.push('verify');
              this.$store.commit('loading', false);
            }).catch((e) => {
              datadogRum.addError(e, {
                message: 'Error in register',
                status: e.response.status,
                statusText: e.response.statusText,
                url: e.request.responseURL,
                method: e.request.method,
                body: e.request.body,
                headers: e.request.headers,
                response: e.response.data
              });
              if (_.get(e, 'response.data.data', false)) {
                this.foundUser = e.response.data.data.profile;
                this.$store.commit('loading', false);
                this.confirmDialog = true;
              } else {
                this.errorMessage = _.get(e, 'response.data.message', 'An error occurred, please try again later.');
                this.$store.commit('loading', false);
              }
            });
          }
        }
      });
    },
    login() {
      this.$router.push('login');
    }
  },
  computed: {
    nationalId() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
    filterGender() {
      if (this.nationalId === 10) {
        return [
          { value: 'Male', label: 'Male' },
          { value: 'Female', label: 'Female' },
          { value: 'Non-binary', label: 'Non-binary' }
        ];
      }
      return [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Other', label: 'Other' }
      ];
    }
  },
};
</script>

<style scoped lang="scss">
.content-card {
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 2em;
  width: 90%;
  max-width: 30em;
}

.su-title {
  text-align: center;
  font-size: 1.5em;
}
.su-subtitle {
  text-align: center;
  margin-bottom: 1em;
  font-size: 0.9em;
  line-height: 1.4;
  color: #666;
  max-width: 85%;
  margin-left: auto;
  margin-right: auto;
}

.t-right {
  text-align: right;
}

.t-center {
  text-align: center;
}

.required {
  color: $highlight;
  margin-left: 0.2em;
}

.term {
  font-size: 0.8em;
}

.row-space {
  margin-top: 1em;
}

.input-space {
  margin-top: 0.5em;
}

.ac-btn {
  width: 100%;
  background-color: $highlight !important;
  border: 0;
}

.width-100 {
  width: 100%;
}
</style>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>
